
const digest = 'af081d96a0df5e582e36508357380f83219799abfb35a3fc1dc00a90ddb999ab';
const classes = {"item":"_item_1cm8m_1","disabled":"_disabled_1cm8m_9","patient":"_patient_1cm8m_13","controls":"_controls_1cm8m_16","isLate":"_isLate_1cm8m_19","patientImageContainer":"_patientImageContainer_1cm8m_30","patientImage":"_patientImage_1cm8m_30","countDownBadge":"_countDownBadge_1cm8m_43","badge":"_badge_1cm8m_52","red":"_red_1cm8m_61","patientData":"_patientData_1cm8m_64","title":"_title_1cm8m_69","date":"_date_1cm8m_75","text":"_text_1cm8m_79","mt20":"_mt-20_1cm8m_86","content":"_content_1cm8m_89","note":"_note_1cm8m_95","noteButton":"_noteButton_1cm8m_100","light":"_light_1cm8m_109","lateText":"_lateText_1cm8m_112","caseForwarder":"_caseForwarder_1cm8m_119","contentItem":"_contentItem_1cm8m_124","lightGrey":"_lightGrey_1cm8m_130","noGap":"_noGap_1cm8m_135","green":"_green_1cm8m_142","orange":"_orange_1cm8m_146","none":"_none_1cm8m_150","gap30":"_gap30_1cm8m_154","disabledInfo":"_disabledInfo_1cm8m_167","disabledInfoTitle":"_disabledInfoTitle_1cm8m_173","disabledInfoValue":"_disabledInfoValue_1cm8m_178","chatPreviewButton":"_chatPreviewButton_1cm8m_184"};
const css = `._item_1cm8m_1 {
  font-family: Rubik, sans-serif;
  display: flex;
  flex-direction: row;
  width: 100%;
  border: 1px solid #eaedf3;
  border-top: 0;
}
._item_1cm8m_1._disabled_1cm8m_9 {
  background-color: #eaedf3;
  border-color: #d8dce4;
}
._item_1cm8m_1._disabled_1cm8m_9 ._patient_1cm8m_13 {
  border-color: #d8dce4;
}
._item_1cm8m_1._disabled_1cm8m_9 ._controls_1cm8m_16 {
  border-color: #d8dce4;
}
._item_1cm8m_1._isLate_1cm8m_19 {
  background-color: #f8dadb;
}
._item_1cm8m_1 ._patient_1cm8m_13 {
  display: flex;
  border-right: 1px solid #eaedf3;
  padding: 24px 24px;
  gap: 16px;
  min-width: 350px;
  max-width: 350px;
}
._item_1cm8m_1 ._patient_1cm8m_13 ._patientImageContainer_1cm8m_30 {
  display: flex;
  flex-direction: column;
  position: relative;
  align-items: center;
  height: fit-content;
}
._item_1cm8m_1 ._patient_1cm8m_13 ._patientImageContainer_1cm8m_30 ._patientImage_1cm8m_30 {
  width: 64px;
  height: 64px;
  border-radius: 100%;
  object-fit: cover;
}
._item_1cm8m_1 ._patient_1cm8m_13 ._patientImageContainer_1cm8m_30 ._countDownBadge_1cm8m_43 {
  color: #fff;
  font-size: 12px;
  font-weight: 500;
  position: absolute;
  padding: 2px 5px;
  border-radius: 4px;
  top: -10px;
}
._item_1cm8m_1 ._patient_1cm8m_13 ._patientImageContainer_1cm8m_30 ._badge_1cm8m_52 {
  color: #fff;
  font-size: 12px;
  font-weight: 500;
  position: absolute;
  padding: 2px 5px;
  border-radius: 4px;
  bottom: -10px;
}
._item_1cm8m_1 ._patient_1cm8m_13 ._patientImageContainer_1cm8m_30 ._red_1cm8m_61 {
  background-color: #f12848;
}
._item_1cm8m_1 ._patient_1cm8m_13 ._patientData_1cm8m_64 {
  display: flex;
  gap: 3px;
  flex-direction: column;
}
._item_1cm8m_1 ._patient_1cm8m_13 ._patientData_1cm8m_64 ._title_1cm8m_69 {
  font-size: 14px;
  font-weight: 500;
  margin-top: 8px;
  color: #000000;
}
._item_1cm8m_1 ._patient_1cm8m_13 ._patientData_1cm8m_64 ._date_1cm8m_75 {
  color: #3e3f42;
  font-size: 12px;
}
._item_1cm8m_1 ._patient_1cm8m_13 ._patientData_1cm8m_64 ._text_1cm8m_79 {
  color: #3e3f42;
  font-size: 14px;
}
._item_1cm8m_1 ._patient_1cm8m_13 ._patientData_1cm8m_64 ._text_1cm8m_79 span {
  color: #9ea0a5;
}
._item_1cm8m_1 ._patient_1cm8m_13 ._patientData_1cm8m_64 ._mt-20_1cm8m_86 {
  margin-top: 20px;
}
._item_1cm8m_1 ._content_1cm8m_89 {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  padding: 24px;
}
._item_1cm8m_1 ._content_1cm8m_89 ._note_1cm8m_95 {
  font-size: 14px;
  color: #3e3f42;
  font-weight: 400;
}
._item_1cm8m_1 ._content_1cm8m_89 ._noteButton_1cm8m_100 {
  font-weight: 400;
}
._item_1cm8m_1 ._content_1cm8m_89 ._title_1cm8m_69 {
  font-size: 14px;
  font-weight: 500;
  color: #000000;
  margin-bottom: 6px;
}
._item_1cm8m_1 ._content_1cm8m_89 ._title_1cm8m_69 ._light_1cm8m_109 {
  font-weight: 400;
}
._item_1cm8m_1 ._content_1cm8m_89 ._lateText_1cm8m_112 {
  font-size: 14px;
  font-weight: 500;
  color: #c53127;
  margin-bottom: 6px;
  text-transform: uppercase;
}
._item_1cm8m_1 ._content_1cm8m_89 ._caseForwarder_1cm8m_119 {
  max-width: 490px;
  margin-top: 6px;
  margin-bottom: 6px;
}
._item_1cm8m_1 ._content_1cm8m_89 ._contentItem_1cm8m_124 {
  font-size: 14px;
  color: #000000;
  display: flex;
  gap: 5px;
}
._item_1cm8m_1 ._content_1cm8m_89 ._contentItem_1cm8m_124 ._lightGrey_1cm8m_130 {
  color: #9ea0a5;
  font-weight: 400;
  min-width: 140px;
}
._item_1cm8m_1 ._content_1cm8m_89 ._contentItem_1cm8m_124 ._noGap_1cm8m_135 {
  min-width: auto;
}
._item_1cm8m_1 ._content_1cm8m_89 ._contentItem_1cm8m_124 ._red_1cm8m_61 {
  font-weight: 600;
  color: #d81616;
}
._item_1cm8m_1 ._content_1cm8m_89 ._contentItem_1cm8m_124 ._green_1cm8m_142 {
  font-weight: 600;
  color: #619612;
}
._item_1cm8m_1 ._content_1cm8m_89 ._contentItem_1cm8m_124 ._orange_1cm8m_146 {
  font-weight: 600;
  color: #f28a11;
}
._item_1cm8m_1 ._content_1cm8m_89 ._contentItem_1cm8m_124 ._none_1cm8m_150 {
  font-weight: 600;
  color: #cccccc;
}
._item_1cm8m_1 ._content_1cm8m_89 ._gap30_1cm8m_154 {
  gap: 30px;
}
._item_1cm8m_1 ._controls_1cm8m_16 {
  min-width: 300px;
  max-width: 300px;
  border-left: 1px solid #eaedf3;
  display: flex;
  flex-direction: column;
  text-align: center;
  padding: 24px;
  gap: 24px;
}
._item_1cm8m_1 ._controls_1cm8m_16 ._disabledInfo_1cm8m_167 {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 15px;
}
._item_1cm8m_1 ._controls_1cm8m_16 ._disabledInfo_1cm8m_167 ._disabledInfoTitle_1cm8m_173 {
  color: #9ea0a5;
  font-size: 14px;
  font-weight: 400;
}
._item_1cm8m_1 ._controls_1cm8m_16 ._disabledInfo_1cm8m_167 ._disabledInfoValue_1cm8m_178 {
  font-weight: 400;
  font-size: 14px;
  color: #000000;
}

._chatPreviewButton_1cm8m_184 {
  font-weight: 400;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  